import React, { createContext, useContext, useState } from 'react';

const ApiCacheContext = createContext();

export const useApiCache = () => {
  const context = useContext(ApiCacheContext);
  if (!context) {
    throw new Error('useApiCache must be used within an ApiCacheProvider');
  }
  return context;
};

export const ApiCacheProvider = ({ children }) => {
  const [cache, setCache] = useState({});
  const [loading, setLoadingState] = useState({});

  const getCachedData = (key) => {
    return cache[key] || null;
  };

  const setCachedData = (key, data) => {
    setCache(prev => ({
      ...prev,
      [key]: {
        data,
        timestamp: Date.now()
      }
    }));
  };

  const isCacheValid = (key, maxAge = 5 * 60 * 1000) => { // 5 minutes default
    const cached = cache[key];
    if (!cached) return false;
    return (Date.now() - cached.timestamp) < maxAge;
  };

  const clearCache = (key) => {
    if (key) {
      setCache(prev => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
    } else {
      setCache({});
    }
  };

  const setLoading = (key, isLoading) => {
    setLoadingState(prev => ({
      ...prev,
      [key]: isLoading
    }));
  };

  const isLoading = (key) => {
    return loading[key] || false;
  };

  const value = {
    getCachedData,
    setCachedData,
    isCacheValid,
    clearCache,
    setLoading,
    isLoading
  };

  return (
    <ApiCacheContext.Provider value={value}>
      {children}
    </ApiCacheContext.Provider>
  );
};
